/** Copyright (C) 2022 Trend Micro Inc. All rights reserved. */

export interface InputErrorType {
  NONE: 'none'
  EMPTY: 'empty'
  INVALID: 'invalid'
}

const INPUT_ERROR: InputErrorType = {
  NONE: 'none',
  EMPTY: 'empty',
  INVALID: 'invalid',
}

export default INPUT_ERROR
